import api from '../services/api';
import { createBaseModule } from './base';

export default createBaseModule( {
  state: {

  },
  mutations: {

  },
  actions: {
    async fetchApp({ commit, state }) {

      commit('RESET_STATE');

      try {
        commit('SET_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await api.get('api/app/');
        commit('SET_DATA', {data:response.data.data});
        commit('SET_ERROR', null);
      } catch (error) {
        commit('SET_ERROR', error.message?error.message:'Ошибка при загрузке');
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },
  getters: {
    app: state => state.data,
    roleOptions: state => state.data && state.data.role?state.data.role:[],
    supplierOptions: state => state.data && state.data.supplier?state.data.supplier:[],
    columnSettings: state => state.data && state.data.column_settings?state.data.column_settings:{},
    helpSettings: state => state.data && state.data.help_settings?state.data.help_settings:{},
    appLoading: state => state.loading,
    appError: state => state.error,
    appLoaded: state => state.loaded,
  }
})
